"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var useClickOutside_1 = __importDefault(require("../hooks/useClickOutside"));
var Icon_1 = __importDefault(require("./Icon"));
require("@popperjs/core");
var Menu_1 = __importDefault(require("./Menu"));
var Dropdown = function (_a) {
    var options = _a.options, value = _a.value, onChange = _a.onChange, className = _a.className, multi = _a.multi, _b = _a.placeholder, placeholder = _b === void 0 ? "Select Item" : _b, disabled = _a.disabled, scrollbar = _a.scrollbar, icon = _a.icon, keepOpen = _a.keepOpen, sortable = _a.sortable, onSort = _a.onSort, _c = _a.variant, variant = _c === void 0 ? 'primary' : _c, placement = _a.placement, fallbackPlacement = _a.fallbackPlacement;
    var _d = __read((0, react_1.useState)(false), 2), open = _d[0], setOpen = _d[1];
    var referenceRef = (0, react_1.useRef)(null);
    var ref = (0, useClickOutside_1.default)(function () {
        setOpen(false);
    });
    var valueAsList = value || [];
    var selectedOptions = options.filter(function (o) {
        return multi ? valueAsList.includes(o.value) : o.value === value;
    });
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-dropdown", className), ref: ref },
        react_1.default.createElement("button", { type: "button", ref: referenceRef, className: (0, classnames_1.default)("ui-dropdown-button", open && 'active', disabled && "disabled", "ui-dropdown-button-" + variant), "data-bs-toggle": "dropdown", "aria-expanded": "false", onClick: function () {
                setOpen(!open);
            } },
            icon ? react_1.default.createElement(Icon_1.default, { icon: icon }) : null,
            selectedOptions.length === 0 ? placeholder : null,
            selectedOptions.length > 0
                ? selectedOptions.map(function (o) { return o.label; }).join(", ")
                : null,
            open ? react_1.default.createElement(Icon_1.default, { icon: "arrow_drop_up", className: "ui-dropdown-arrow" }) : null,
            !open ? react_1.default.createElement(Icon_1.default, { icon: "arrow_drop_down", className: "ui-dropdown-arrow" }) : null),
        react_1.default.createElement(Menu_1.default, { open: open, scrollbar: scrollbar, trigger: referenceRef.current, options: options.map(function (o) { return ({
                divider: o.divider,
                value: o.value ? String(o.value) : undefined,
                label: o.label,
                disabled: o.disabled,
                leadingIcon: o.leadingIcon,
                trailingIcon: o.trailingIcon,
                checked: multi && valueAsList.includes(o.value),
                unchecked: multi && !valueAsList.includes(o.value),
            }); }), onClose: function () { return null; }, sortable: sortable, onSort: onSort, onClick: function (_, i) {
                var o = options[i];
                onChange(o, multi
                    ? valueAsList.includes(o.value)
                        ? valueAsList.filter(function (v) { return v !== o.value; })
                        : __spreadArray(__spreadArray([], __read(valueAsList), false), [o.value], false)
                    : o.value);
                if (!multi && !keepOpen) {
                    setOpen(false);
                }
            }, placement: placement, fallbackPlacement: fallbackPlacement })));
};
exports.default = Dropdown;
